// extracted by mini-css-extract-plugin
module.exports = {"host":"ButtonGroup_host___UG1Q"};